module.exports = __webpack_public_path__ + "img/ico-sementes-w.32a37389.png";